import { createIcon } from '../icon'
import FreeShippingBigIcon from '../svg/FreeShippingBigIcon'

export const FreeShippingBigIconDefault = createIcon(FreeShippingBigIcon)
